<template>
  <div class="mains">
    <van-nav-bar title="充值"
                 left-text="返回"
                 left-arrow
                 @click-left="onClickLeft" />
    <div class="content">
      <van-icon class="success_icon"
                :name="require('../assets/paySuccess.png')" />
      <div class="success_title">充值成功！</div>

      <div class="pay_info">
        <div class="info_item">
          <div class="info_title">充值类型:</div>
          <div class="info_content">{{type}}</div>
        </div>
        <div class="info_item">
          <div class="info_title">充值户号:</div>
          <div class="info_content">{{room}}</div>
        </div>
        <div class="info_item">
          <div class="info_title">实付金额:</div>
          <div class="info_content">￥{{money}}</div>
        </div>
        <div class="info_item">
          <div class="info_title">完成时间:</div>
          <div class="info_content">{{time}}</div>
        </div>

      </div>

      <van-button round
                  plain
                  hairline
                  color="#C62721"
                  type="info"
                  @click="toDetail">完成</van-button>

    </div>
  </div>
</template>

<script>
export default {
  name: 'PaySuccess',
  data() {
    return {
      room: '',
      type: '',
      money: '',
      time: ''
    };
  },
  created() {

  },
  mounted() {
    if (window.sessionStorage.getItem('openInfo') == null
      || JSON.parse(window.sessionStorage.getItem('openInfo')).roomName == null
      || window.sessionStorage.getItem('infoType') == null
      || window.sessionStorage.getItem('money') == null
      || window.sessionStorage.getItem('orderTime') == null) {
      this.$router.push('/detail')
    }

    this.room = JSON.parse(window.sessionStorage.getItem('openInfo')).roomName
    this.type = window.sessionStorage.getItem('infoType') == 'E' ? '电费' : '水费'
    this.money = window.sessionStorage.getItem('money')
    this.time = window.sessionStorage.getItem('orderTime')
  },
  methods: {
    onClickLeft() {
      this.$router.push('/pay')
    },
    toDetail() {
      this.$router.push('/detail')
    },
  },
};
</script>

<style scoped lang="less">
.mains {
  background: white;
  height: 100vh;
}

.content {
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .success_icon {
    font-size: 80px;
    margin-top: 40px;
  }
  .success_title {
    margin-top: 20px;
    font-size: 25px;
    font-weight: 600;
  }

  .pay_info {
    margin-top: 20px;
    width: 100%;
  }

  .info_item {
    font-size: 15px;
    display: flex;
    padding: 15px 10px;
    justify-content: space-between;
    border-bottom: 1px solid rgba(190, 181, 181, 0.6);
  }

  .van-button {
    margin-top: 25px;
    width: 100%;
  }
}
</style>
